/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ detail: NonNullable<unknown> }} Cc_Embed_Error_UsageInputs */



/**
* | output |
* | --- |
* | "Local processing couldn't start: {detail}" |
*
* @param {Cc_Embed_Error_UsageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cc_embed_error_usage = /** @type {((inputs: Cc_Embed_Error_UsageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Embed_Error_UsageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le traitement local n'a pas pu démarrer : ${i?.detail}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die lokale Verarbeitung konnte nicht gestartet werden: ${i?.detail}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile avviare l'elaborazione locale: ${i?.detail}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось запустить локальную обработку: ${i?.detail}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo iniciar el procesamiento local: ${i?.detail}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`本地处理无法启动：${i?.detail}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ローカル処理を開始できませんでした: ${i?.detail}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्थानीय प्रोसेसिंग शुरू नहीं हो सकी: ${i?.detail}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível iniciar o processamento local: ${i?.detail}`)
	return /** @type {LocalizedString} */ (`Local processing couldn't start: ${i?.detail}`)
});